// @givmo/app-admin — the company deposit quote, addressed by URL (CAM-BE11 review F1).
//
// ══ WHY THIS FILE EXISTS ══════════════════════════════════════════════════════════════════════
// `GET /admin/company/wallet/deposit/quote` landed on the backend AFTER the committed OpenAPI
// snapshot (`packages/api-client/openapi.json`) was last refreshed, so there is no generated SDK
// operation, type or query factory for it. `agent_docs/api-client.md` § *A whole ROUTE the snapshot
// lacks* is the sanctioned disposition: call the configured `givmoClient`, which carries the whole
// interceptor stack (Bearer, App Check, `X-Request-Id`, the `{errors:[…]}` → `GivmoError` mapping).
//
// ══ WHY THE DIALOG ASKS THE SERVER ═════════════════════════════════════════════════════════════
// The Add funds dialog states what the card is charged BEFORE charging it. The charge prices the
// STORED card's brand row, the company's own cover-fees setting and the deposit's platform-fee
// waiver; `GET /fees/processor` withholds brand rows by design, so no client-side arithmetic over it
// can know what an AMEX company card is charged. The quote runs the charge's own resolution and
// answers both requests the dialog can make (covered and not). It moves no money and is Owner-only
// (`company_wallet:deposit`, the deposit's own permission).

import { givmoClient } from '@givmo/api-client';

/** The one route this module talks to. */
export const DEPOSIT_QUOTE_URL = '/admin/company/wallet/deposit/quote';

/** What a deposit of `amount` (the wire decimal string, e.g. "20.00") on saved card `cardId` costs. */
export interface DepositQuoteRequest {
  readonly amount: string;
  readonly cardId: string;
}

/** The TanStack Query key for one quote: a different amount or card is a different price. */
export function depositQuoteQueryKey(
  amount: string | null,
  cardId: string | null,
): readonly unknown[] {
  return ['company-deposit-quote', amount, cardId];
}

/** Read the quote. The body is `unknown`: it goes through `toDepositQuote`, which fails closed. */
export async function fetchDepositQuote(request: DepositQuoteRequest): Promise<unknown> {
  const { data } = await givmoClient.get({
    url: DEPOSIT_QUOTE_URL,
    query: { amount: request.amount, card_id: request.cardId },
    throwOnError: true,
  });
  return data;
}
